import { api } from '../../functions/api';
import { ApiPath } from '../../api/ApiPath';

type Data = {
  customerId: number | null;
  assetIds: number[];
  reassign: boolean;
};

export async function assignAssets(data: Data): Promise<void> {
  return api({
    url: ApiPath.AssetsAssign,
    method: 'post',
    data,
  });
}
